// Stellarium Web - Copyright (c) 2018 - Noctua Software Ltd
//
// This program is licensed under the terms of the GNU AGPL v3, or
// alternatively under a commercial licence.
//
// The terms of the AGPL v3 license can be found in the main directory of this
// repository.

<template>
<v-dialog max-width="600" v-model="$store.state.private_elements.showAboutDialog">
  <v-card v-if="$store.state.private_elements.showAboutDialog" class="secondary white--text">
    <v-card-title><div class="text-h5">About</div></v-card-title>
    <v-card-text>
      <p>Welcome to Stellarium Web, an online planetarium running in your web browser based on the open source
      <a href="https://github.com/Stellarium/stellarium-web-engine" target="_blank">Stellarium Web Engine</a> project.
      Please report any bugs or ask questions on <a href="https://www.stellarium-labs.com/" target="_blank">www.stellarium-labs.com</a> or on our <a href="https://github.com/Stellarium/stellarium-web-engine" target="_blank">Github page</a>.</p>

      <p>This web version of Stellarium is a <a href="https://github.com/Stellarium/stellarium-web-engine" target="_blank">2-persons project</a>: Fabien Chereau the original creator of Stellarium and his brother Guillaume.</p>

      <v-card flat>
        <v-card-text>
          <v-row>
            <v-col cols="6">
              <div style="margin-left: 0px"><img id="stellarium-mobile-plus-img" src="../assets/smp.png" width="200" height="200" alt="Stellarium Web Logo" style="width: 100%; height: 100%;"/></div>
            </v-col>
            <v-col cols="6">
              If you like it, please consider <a href="https://opencollective.com/stellarium/donate" target="_blank">donating to the Stellarium Projet</a> or buying our <a href="https://www.stellarium-labs.com/stellarium-mobile-plus/" target="_blank">Mobile Version</a>.
              The money will be used to pay the server costs and hopefully also the development costs.</p>
              <span style="padding-left: 0px;">
                <a href="https://play.google.com/store/apps/details?id=com.noctuasoftware.stellarium_plus&referrer=utm_source%3Dstellariumweb%26utm_medium%3Daboutdialog" target="_blank"><img src="../assets/google-download.png" width="134" height="41" alt="Google Play Download"/></a>
                <a href="https://itunes.apple.com/us/app/stellarium-mobile-plus-sky-map/id1458716890" target="_blank"><img src="../assets/apple-download.png"  width="119" height="41" alt="Apple Store Download"/></a>
              </span>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <p>By using this website, you agree with our <a v-on:click.stop="$store.state.private_elements.showPrivacyDialog = true">Privacy Policy</a></p>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer><v-btn class="blue--text darken-1" text @click.native="$store.state.private_elements.showAboutDialog = false">Close</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
</template>

<script>
export default {
  data: function () {
    return {
    }
  },
  methods: {
  }
}
</script>

<style>
a {
  color: #82b1ff;
}
</style>
